import { createTheme } from '@mui/material/styles';

import { mediaBreakpoints } from './mediaBreakpoints';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#573bff',
    },
  },
  breakpoints: {
    values: {
      ...mediaBreakpoints,
    },
  },
  typography: {
    fontFamily: [
      'AppleSDGothicNeo',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
});
